export default __webpack_public_path__ + "static/media/Tellstory.120b8ca5.png";